if(!customElements.get('active-filters')) {
  class ActiveFilters extends HTMLElement {
    constructor() {
      super();
      this.collectionGrid = this.closest('collection-grid');
      this.filtersFooter = document.querySelector('.js-filters-footer');
      this.activeCount = document.querySelector('.js-active-count-mobile');
    }
    
    setActiveCount(count) {
      this.activeCount.innerHTML = count > 0 ?  `(${count})` : '';

      if(count > 0) return;
      this.removeClearAll();
    }

    clearAll() {
      this.innerHTML = '';
      this.setActiveCount();
    }

    /**
     * createElement - Creates a button element for every active filter
     * 
     * @param {HTMLInputElement} input - Filter input element
     * @param {String} key - Filter meta key
     * 
     * @returns {String} - HTML text string
     */

    createElement(input, key) {
      var inputValue = input.value;
      inputValue = inputValue.replace('rooll_','');
      return `<button data-key="${key}" data-value="${input.value}">
        ${inputValue}

        <svg id="Group_5022" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <g id="Ellipse_195" data-name="Ellipse 195" fill="none" stroke="#d0d2d3" stroke-width="1">
            <circle cx="9" cy="9" r="9" stroke="none"/>
            <circle cx="9" cy="9" r="8.5" fill="none"/>
          </g>
          <g id="Group_5021" data-name="Group 5021" transform="translate(6.789 6.696)">
            <line id="Line_134" data-name="Line 134" x2="4.723" y2="4.724" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
            <line id="Line_135" data-name="Line 135" x1="4.723" y2="4.724" transform="translate(0 0)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
          </g>
        </svg>
      </button>`;
      
    }

    /**
     * addClearAllButton - Creates a new button that clears all filters
     */

    addClearAllButton() {
      if(this.querySelector('.js-clear-all-active')) return;

      const button = document.createElement('button');
      button.innerHTML = 'Clear All';
      button.classList.add('active__clear-all', 'large-up-hide', 'js-clear-all-active');
      this.appendChild(button);
    }

    /**
     * update - Updates the active-filters element by adding the new buttons returned from {@link createElement}}
     * 
     * @param {NodeList} inputs - List of input nodes
     * @param {String} key - Filter meta key (Optional)
     */
    
    update(inputs, key) {
      let innerHTML = '';
      
      inputs.forEach(input => {
        if(input.checked) {
          if(this.querySelector(`[data-value="${input.value}"]`)) return;
          innerHTML += this.createElement(input, key ? key : input.dataset.key);
        }
      });
  
      this.innerHTML += innerHTML;
      this.filtersFooter.updateClearButton(innerHTML != '');

      window.setTimeout(() => {
        this.setActiveCount(this.querySelectorAll('button:not([class])').length);
      }, 0);

      if(innerHTML != '') this.addClearAllButton();
    }
    
    /**
     * add - Adds a single button to the active-filters element
     * 
     * @param {HTMLInputElement} input - Filter input element
     * @param {String} key - Filter meta key 
     */

    add(input, key) {
      const exists = this.querySelector(`[data-value="${input.value}"]`);
      if(exists) return;
      
      this.innerHTML += this.createElement(input, key);
      this.addClearAllButton();

      this.setActiveCount(this.querySelectorAll('button:not([class])').length);
    }

    /**
     * remove - Removes a single button to the active-filters element
     * 
     * @param {HTMLInputElement} input - Filter input element
     * @param {String} key - Filter meta key 
     */

    remove(input, key) {
      const button = this.querySelector(`[data-key="${key}"][data-value="${input.value}"]`);
      if(button) button.parentElement.removeChild(button);

      if(this.children.length == 1) this.clearAll();

      this.setActiveCount(this.querySelectorAll('button:not([class])').length);
    }

    removeClearAll() {
      const clearAll = this.querySelector('.js-clear-all-active');

      if(!clearAll) return;

      clearAll.remove();
    }

    /**
     * toggle - Add or remove a single button to the active-filters element based on the {@link checked} parameter
     * 
     * @param {HTMLInputElement} input - Filter input element
     * @param {Boolean} checked - True: calls {@link add}, False: calls {@link remove}
     * @param {String} key - Filter meta key
     */

    toggle(input, checked, key) {
      return checked ? this.add(input, key) : this.remove(input, key);
    }

    connectedCallback() {
      if(!this.collectionGrid) return;

      this.addEventListener('click', (event) => {
         

       setTimeout(function(e){
        var length = $('.redemption .grid__inner.js-grid-inner .grid__inner-item').length;

        $('.redemption .js-filter-count').html('');
        $('.redemption .js-filter-count').html(length+' Result');    
      },2000);
          
        const button = event.target.closest('button');
        if(!button) return;

        if(button.classList.contains('js-clear-all-active')) return this.collectionGrid.removeAll();

        const value = button.dataset.value;
        const key = button.dataset.key;
        var removed = $('.filter.js-filter-block[data-key] .filter-item[data-tag="'+value+'"]');
        removed.parents('.filter.js-filter-block[data-key]').find(".item_check").prop("disabled", false);
        const input = this.collectionGrid.querySelector(`input[value="${value}"]`);
        if(input) input.checked = false;

        if(key && value) this.collectionGrid.applyFilter(value, false, key);
        

        button.parentNode.removeChild(button);
        this.setActiveCount(this.querySelectorAll('button:not([class])').length);
      });
    }
  }

  customElements.define('active-filters', ActiveFilters);
}
